/**
 * Units for the auto teardown timer.
 *
 * The form lets the user say "45 minutes", "4 hours" or "14 days"; the cluster
 * document stores minutes, which is what the timer daemon reads. Both the form
 * section and the form/API mapping need this table, so it lives apart from
 * either - a mismatch between them is a timer that fires at the wrong hour.
 *
 * Mirrors UNITS in the API's nodus-core/src/libs/autoTeardown.js.
 *
 * Feature: cluster-auto-teardown-timer
 */

export const TIMER_UNITS = [
    { value: 'minutes', label: 'minutes', factor: 1 },
    { value: 'hours', label: 'hours', factor: 60 },
    { value: 'days', label: 'days', factor: 1440 },
];

export const DEFAULT_TIMER_UNIT = 'hours';

export const unitFactor = (unit) =>
    (TIMER_UNITS.find(u => u.value === unit) || TIMER_UNITS.find(u => u.value === DEFAULT_TIMER_UNIT)).factor;

/**
 * Duration filled in when the timer is switched on, so the section opens in a
 * valid state instead of showing an error against a field nobody has typed in
 * yet. Long enough to be a plausible working session rather than a number
 * chosen to be edited.
 */
export const DEFAULT_TIMER_VALUE = 8;
